import { render, staticRenderFns } from "./CompanyPreferencesSetting.vue?vue&type=template&id=a53032c4&scoped=true"
import script from "./CompanyPreferencesSetting.vue?vue&type=script&lang=js"
export * from "./CompanyPreferencesSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyPreferencesSetting.vue?vue&type=style&index=0&id=a53032c4&prod&lang=scss&scoped=true"
import style1 from "./CompanyPreferencesSetting.vue?vue&type=style&index=1&id=a53032c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53032c4",
  null
  
)

export default component.exports